export default "https://cdn-static.gokick.com/assets/4e3548e0bbc963e39203d4ae4090204efad0894d/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";